/**
 * HomeENDemoHelpContentView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait HomeENDemoHelpContent
 */

import { useHomeENDemoHelpContentLogic } from '@/hooks/traits/useHomeENDemoHelpContentLogic';
import type { HomeENDemoHelpContentConfig } from '@/hooks/traits/useHomeENDemoHelpContentLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { HomeENDemoHelpTicket } from '@app/shared';
import { HomeENDemoTicketQueueView } from '@/components/traits/HomeENDemoTicketQueueView';
import { Stack } from '@almadar/ui/components';
import { Typography } from '@almadar/ui/components';
import { HomeENDemoHelpStatsView } from '@/components/traits/HomeENDemoHelpStatsView';
import { UISlotComponent, renderPatternValue } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';
import { useTranslate } from '@almadar/ui/hooks';

interface HomeENDemoHelpContentViewProps {
  config?: Partial<HomeENDemoHelpContentConfig>;
}

export function HomeENDemoHelpContentView({ config: propsConfig }: HomeENDemoHelpContentViewProps) {
  const { t: __t, locale: __locale } = useTranslate();
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useHomeENDemoHelpContentLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['HomeENDemoHelpTicket'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="HomeEN" trait="HomeENDemoHelpContent">
      {slotWriter['main'] === 'INIT' ? (<Stack direction="vertical" gap="sm" className="p-4"><Stack direction="horizontal" align="baseline" gap="sm"><Typography content={renderPatternValue(__t("std-almadar-demo-helpdesk-page:page.title"))} variant="h3" /><Typography variant="small" color="muted" content={renderPatternValue(__t("std-almadar-demo-helpdesk-page:page.subtitle"))} /></Stack><HomeENDemoHelpStatsView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><HomeENDemoTicketQueueView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Stack>) : null}
    </TraitScopeProvider>
  );
}

export default HomeENDemoHelpContentView;
